export default {"list":"_02nnq","cols2":"N70HG","cols3":"p2dZc"};